"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageStripe = exports.MessageMultiActions = exports.MessageAction = void 0;
const react_1 = __importDefault(require("react"));
const Element_1 = require("../Element");
const Stack_1 = require("../Stack");
const Button_1 = require("../Button");
const ComboButton_1 = require("../ComboButton/ComboButton");
const Text_1 = require("../Text");
const IconButton_1 = require("../IconButton");
const mapActionVariant = {
    trial: 'light',
    warning: 'dark',
    error: 'dark',
    primary: 'dark',
    info: 'dark',
};
const MessageAction = (_a) => {
    var { children, variant } = _a, buttonProps = __rest(_a, ["children", "variant"]);
    return (react_1.default.createElement(Element_1.Element, { as: "div", css: { flexShrink: 0 } },
        react_1.default.createElement(Button_1.Button, Object.assign({ variant: mapActionVariant[variant] }, buttonProps), children)));
};
exports.MessageAction = MessageAction;
const MessageMultiActions = (_a) => {
    var { children, variant } = _a, props = __rest(_a, ["children", "variant"]);
    return (react_1.default.createElement(ComboButton_1.ComboButton, Object.assign({ variant: mapActionVariant[variant] }, props), children));
};
exports.MessageMultiActions = MessageMultiActions;
const backgroundVariants = {
    trial: '#644ED7',
    warning: '#F7CC66',
    error: '#F5A8A8',
    primary: 'button.background',
    info: '#7DA1F9',
};
const colorVariants = {
    trial: 'inherit',
    warning: '#0E0E0E',
    error: '#0E0E0E',
    primary: 'button.foreground',
    info: '#0E0E0E',
};
const MessageStripe = ({ children, corners = 'rounded', // Opposite of the value in v2 just to not cause regressions.
variant = 'trial', justify = 'center', onDismiss, }) => {
    let hasAction;
    const augmentedChildren = react_1.default.Children.map(children, child => {
        if (react_1.default.isValidElement(child) && child.type === exports.MessageAction) {
            hasAction = true;
            return react_1.default.cloneElement(child, {
                variant,
            });
        }
        if (react_1.default.isValidElement(child) && child.type === exports.MessageMultiActions) {
            hasAction = true;
            return react_1.default.cloneElement(child, {
                variant,
            });
        }
        return (react_1.default.createElement(Text_1.Text, { size: 13, lineHeight: "16px" }, child));
    });
    return (react_1.default.createElement(Element_1.Element, { paddingY: hasAction ? 2 : 3, paddingX: 4, paddingRight: onDismiss ? 11 : undefined, css: {
            backgroundColor: backgroundVariants[variant],
            color: colorVariants[variant],
            position: 'relative',
            borderRadius: { rounded: '4px', straight: 0 }[corners],
        } },
        react_1.default.createElement(Stack_1.Stack, { direction: "horizontal", justify: justify, align: "center", gap: 2 },
            augmentedChildren,
            onDismiss ? (react_1.default.createElement(Element_1.Element, { css: { position: 'absolute', right: '16px' } },
                react_1.default.createElement(IconButton_1.IconButton, { onClick: onDismiss, css: {
                        color: colorVariants[variant],
                        '&:hover:not(:disabled)': { color: colorVariants[variant] },
                    }, name: "cross", title: "Dismiss", variant: "square" }))) : null)));
};
exports.MessageStripe = MessageStripe;
MessageStripe.Action = exports.MessageAction;
MessageStripe.MultiActions = exports.MessageMultiActions;
MessageStripe.MultiActionsItem = ComboButton_1.ComboButton.Item;
